export class Result<TSuccess, TError> {
    private readonly _isOk: boolean;
    private readonly _resp: TSuccess;
    private readonly _error: TError;

    constructor(isOk: boolean, response: TSuccess, error: TError = null) {
        this._isOk = isOk;
        this._resp = response;
        this._error = error;
    }

    public isOk(): boolean {
        return this._isOk;
    }

    response(): TSuccess {
        return this._resp;
    }

    error(): TError {
        return this._error;
    }
}
